import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnlocked: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconUnlocked"><Path d="M7.75 9.75H16.25C17.9069 9.75 19.25 11.0931 19.25 12.75V18.25C19.25 19.9069 17.9069 21.25 16.25 21.25H7.75C6.09315 21.25 4.75 19.9069 4.75 18.25V12.75C4.75 11.0931 6.09315 9.75 7.75 9.75ZM7.75 9.75V7C7.75 4.65279 9.65279 2.75 12 2.75C14.0926 2.75 15.832 4.26237 16.1847 6.25371" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M12 14V17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconUnlocked;
